export default __webpack_public_path__ + "static/404bg-0138d193d0a7e186e56bdf333af50489.jpg";